module.exports = __webpack_public_path__ + "static/media/2 Copa del Sol Trophies.d7bf72b4.JPG";